import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState, useContext } from 'react';
import { FormGroup, Label, Input, Col, Row, Button } from 'reactstrap';
import Address from './Address';
import AvatarInfo from './AvatarInfo';
import Phone from './Phone';
import UserProvider, { UserContext } from '../userContext';
import { withSection } from '../withSection';
import CommonSelect from '../../../Basic/Select';
import { getCountry, getTimeZone, saveUserData, getCountryCodeList } from '../../api';
import { saveDataFormatFactory } from '../formatFactoryTool';
import { notifyErrorToast } from '../../utils/errorToast';
var Language = withSection(function (_ref) {
  var languageList = _ref.languageList,
      countryList = _ref.countryList,
      isCountryLoading = _ref.isCountryLoading,
      trans = _ref.trans;

  var _useContext = useContext(UserContext),
      userData = _useContext.userData,
      updateUserData = _useContext.updateUserData;

  var profile = userData.profile;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      countryGeoNameId = _useState2[0],
      setCountryGeoNameId = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      timeZoneList = _useState4[0],
      setTimeZoneList = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isTimeZoneDisabled = _useState6[0],
      setIsTimeZoneDisabled = _useState6[1];

  useEffect(function () {
    var getTimeZoneList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(countryCode) {
        var _yield$getTimeZone, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsTimeZoneDisabled(true);
                _context.prev = 1;
                _context.next = 4;
                return getTimeZone(countryCode, {
                  catchError: true
                });

              case 4:
                _yield$getTimeZone = _context.sent;
                data = _yield$getTimeZone.data;
                setTimeZoneList(data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);
                setTimeZoneList([]);

              case 13:
                setIsTimeZoneDisabled(false);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      return function getTimeZoneList(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    if (countryGeoNameId && countryList.length) {
      setTimeZoneList([]);

      var _ref3 = countryList.find(function (i) {
        return String(i.geonameId) === String(countryGeoNameId);
      }) || {
        countryCode: ''
      },
          countryCode = _ref3.countryCode;

      countryCode && getTimeZoneList(countryCode);
    }
  }, [countryList, countryGeoNameId]);
  useEffect(function () {
    if (profile.country && profile.country.geonameId) {
      setCountryGeoNameId(profile.country.geonameId);
    }
  }, [profile]);

  var onSelectChange = function onSelectChange(item, name) {
    var profile = _objectSpread(_objectSpread({}, userData.profile), {}, _defineProperty({}, name, item));

    if (name === 'country') {
      var geonameId = item && item.geonameId;
      setCountryGeoNameId(geonameId);
      profile.timeZone = null;
    }

    updateUserData(_objectSpread(_objectSpread({}, userData), {}, {
      profile: profile
    }));
  };

  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "country"
  }, trans('SFxUserPreferencesCountryLabel')), /*#__PURE__*/React.createElement(CommonSelect, {
    showFlag: true,
    renderOption: function renderOption(i) {
      return {
        label: i.countryName,
        value: i.geonameId
      };
    },
    isLoading: isCountryLoading,
    value: profile.country,
    options: countryList,
    onChange: function onChange(item) {
      return onSelectChange(item, 'country');
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    md: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "language"
  }, trans('SFxUserPreferencesLanguageLabel')), /*#__PURE__*/React.createElement(CommonSelect, {
    value: profile.language,
    options: languageList,
    onChange: function onChange(item) {
      return onSelectChange(item, 'language');
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    md: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "timeZone"
  }, trans('SFxUserPreferencesTimeZoneLabel')), /*#__PURE__*/React.createElement(CommonSelect, {
    renderOption: function renderOption(i) {
      return {
        label: i.DstOffset,
        value: i.DstOffset
      };
    },
    isDisabled: isTimeZoneDisabled,
    isLoading: isTimeZoneDisabled,
    value: profile.timeZone,
    noOptionsMessage: function noOptionsMessage() {
      return trans('SFxUserTimeZoneSelectCountryFirst');
    },
    options: timeZoneList,
    onChange: function onChange(item) {
      return onSelectChange(item, 'timeZone');
    }
  }))));
});
var Contact = withSection(function (_ref4) {
  var prefix = _ref4.prefix,
      countryList = _ref4.countryList,
      isCountryLoading = _ref4.isCountryLoading,
      countryCodeList = _ref4.countryCodeList,
      isCountryCodeLoading = _ref4.isCountryCodeLoading,
      trans = _ref4.trans;

  var _useContext2 = useContext(UserContext),
      userData = _useContext2.userData;

  var _userData$profile = userData.profile,
      profile = _userData$profile === void 0 ? {
    email: ''
  } : _userData$profile;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-profile-contact-content")
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "email"
  }, trans('SFxUserPreferencesEmailLabel')), /*#__PURE__*/React.createElement(Input, {
    name: "email",
    readOnly: true,
    defaultValue: profile.email
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-profile-contact-content")
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-profile-contact-title")
  }, trans('SFxUserPreferencesPhoneNumTitle')), /*#__PURE__*/React.createElement(Phone, {
    prefix: prefix,
    countryCodeList: countryCodeList,
    isCountryCodeLoading: isCountryCodeLoading,
    trans: trans
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-profile-contact-content")
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-profile-contact-title")
  }, trans('SFxUserPreferencesAddressesTitle')), /*#__PURE__*/React.createElement(Address, {
    prefix: prefix,
    countryList: countryList,
    isCountryLoading: isCountryLoading,
    trans: trans
  })));
});

var Profile = function Profile(props) {
  var prefix = props.prefix,
      userData = props.userData,
      supportedLanguages = props.staticSource.supportedLanguages,
      userPreferencesCallback = props.userPreferencesCallback,
      isShowAvatar = props.isShowAvatar,
      trans = props.trans;

  var _useState7 = useState(userData),
      _useState8 = _slicedToArray(_useState7, 2),
      currentUserData = _useState8[0],
      setCurrentUserData = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isDisabled = _useState10[0],
      setIsDisabled = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      countryList = _useState12[0],
      setCountryList = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      isCountryLoading = _useState14[0],
      setIsCountryLoading = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      countryCodeList = _useState16[0],
      setCountryCodeList = _useState16[1];

  var _useState17 = useState(true),
      _useState18 = _slicedToArray(_useState17, 2),
      isCountryCodeLoading = _useState18[0],
      setIsCountryCodeLoading = _useState18[1];

  useEffect(function () {
    setCurrentUserData(userData);
  }, [userData]);
  useEffect(function () {
    var getCountryCode = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$getCountryCode, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getCountryCodeList({
                  catchError: true
                });

              case 3:
                _yield$getCountryCode = _context2.sent;
                data = _yield$getCountryCode.data;
                setCountryCodeList(data);
                setIsCountryCodeLoading(false);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                setIsCountryCodeLoading(false);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      return function getCountryCode() {
        return _ref5.apply(this, arguments);
      };
    }();

    var getCountryList = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$getCountry, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getCountry({
                  catchError: true
                });

              case 3:
                _yield$getCountry = _context3.sent;
                data = _yield$getCountry.data;
                setCountryList(data);
                setIsCountryLoading(false);
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                setIsCountryLoading(false);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      return function getCountryList() {
        return _ref6.apply(this, arguments);
      };
    }();

    getCountryList();
    getCountryCode();
  }, []);

  var save = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var profile;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setIsDisabled(true);
              profile = saveDataFormatFactory(currentUserData.profile);
              _context4.prev = 2;
              _context4.next = 5;
              return saveUserData(profile, {
                catchError: true
              });

            case 5:
              userPreferencesCallback(_objectSpread(_objectSpread(_objectSpread({
                currentUserData: currentUserData
              }, profile), {
                changeLanguage: true
              }), {
                isSaveProfileSuccess: 'success'
              }));
              _context4.next = 13;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              setIsDisabled(false);
              notifyErrorToast(trans('SFxAccountSettingsUserProfileSaveError'), _context4.t0);
              userPreferencesCallback({
                currentUserData: userData,
                isSaveProfileSuccess: 'error'
              });

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }));

    return function save() {
      return _ref7.apply(this, arguments);
    };
  }();

  var updateInfo = function updateInfo(data) {
    var newData = _objectSpread(_objectSpread({}, userData), data);

    setCurrentUserData(newData);
    var _newData$profile = newData.profile,
        profile = _newData$profile === void 0 ? {
      firstName: '',
      lastName: ''
    } : _newData$profile;

    if (profile.firstName && profile.lastName) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  return /*#__PURE__*/React.createElement(UserProvider, {
    userData: currentUserData,
    updateUserData: updateInfo
  }, /*#__PURE__*/React.createElement("div", {
    id: "MyProfile"
  }, isShowAvatar && /*#__PURE__*/React.createElement(AvatarInfo, {
    prefix: prefix,
    title: "SFxUserPreferencesBasicInfo",
    userPreferencesCallback: userPreferencesCallback,
    trans: trans
  }), /*#__PURE__*/React.createElement(Language, {
    prefix: prefix,
    title: "SFxUserPreferencesLanguageRegion",
    languageList: supportedLanguages,
    countryList: countryList,
    isCountryLoading: isCountryLoading,
    trans: trans
  }), /*#__PURE__*/React.createElement(Contact, {
    prefix: prefix,
    title: "SFxUserPreferencesContactAddress",
    countryList: countryList,
    countryCodeList: countryCodeList,
    isCountryLoading: isCountryLoading,
    isCountryCodeLoading: isCountryCodeLoading,
    trans: trans
  }), props.myProfileChildrenNode, userData.userId && /*#__PURE__*/React.createElement(Button, {
    className: "".concat(prefix, "-profile-save-btn"),
    size: "sm",
    color: "primary",
    disabled: isDisabled,
    onClick: save
  }, trans('SFxUserPreferencesSaveButton'))));
};

export default Profile;